import * as React from "react";
import { forwardRef } from "react";
const SvgNextSmall = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "Property 1=Disabled, Size=S" }, /* @__PURE__ */ React.createElement("circle", { id: "Ellipse 381", cx: 6, cy: 6, r: 5, fill: "#64748B", stroke: "#020617", strokeWidth: 2 })));
const ForwardRef = forwardRef(SvgNextSmall);
export { ForwardRef as ReactComponent };
